import EventEmitter from 'eventemitter3';
import { Scene } from "../../tools/Scene";
import { Button } from "../../ui/Button";

export class MuteButton{
    
    landscapePosition:Phaser.Math.Vector2;
    portraitPosition:Phaser.Math.Vector2;

    muteButton:Button;
    unmuteButton:Button;

    scene:Phaser.Scene;
    group:Phaser.GameObjects.Group;

    constructor(scene:Phaser.Scene,landscapePosition:Phaser.Math.Vector2,landscapeOrigin?:Phaser.Math.Vector2, portraitPosition?:Phaser.Math.Vector2, portraitOrigin?:Phaser.Math.Vector2){

        this.scene = scene;
        this.landscapePosition = landscapePosition;
        this.portraitPosition = portraitPosition ? portraitPosition : landscapePosition;

        let position;
        let button:Button;
        let group = scene.add.group({});
        this.group = group;

        button = new Button(scene,'mute_button',this.landscapePosition.x,this.landscapePosition.y);
        button.buttonHighlightSprite = 'mute_button';
        button.buttonPressedSprite = 'mute_button_pressed';
        if(landscapeOrigin){
            button.sprite.setOrigin(landscapeOrigin.x, landscapeOrigin.y);
        }
        button.emitter.on('buttonup',this.mute,this);
        this.muteButton = button;
        group.addMultiple(button.group.getChildren());
        button = new Button(scene,'unmute_button',this.landscapePosition.x,this.landscapePosition.y);
        button.buttonHighlightSprite = 'unmute_button';
        button.buttonPressedSprite = 'unmute_button_pressed';
        if(landscapeOrigin){
            button.sprite.setOrigin(landscapeOrigin.x, landscapeOrigin.y);
        }
        button.emitter.on('buttonup',this.unmute,this);
        this.unmuteButton = button;
        group.addMultiple(button.group.getChildren());

        if(localStorage.getItem('mute')){
            this.scene.sound.mute = localStorage.getItem('mute') == 'true';
            this.setMuteButtonState(localStorage.getItem('mute') != 'true');
        }else{
            this.setMuteButtonState(true);
        }
    }

    mute(){
        this.scene.sound.mute = true;
        localStorage.setItem('mute','true');
        this.setMuteButtonState(false);
    }

    unmute(){
        this.scene.sound.mute = false;
        localStorage.setItem('mute','false');
        this.setMuteButtonState(true);
    }

    setMuteButtonState(state:boolean){
        if(state==false){
            if(this.muteButton){
                Phaser.Actions.SetVisible(this.muteButton.group.getChildren(),false);
                this.scene.input.disable(this.muteButton.sprite);
            }
            if(this.unmuteButton){
                Phaser.Actions.SetVisible(this.unmuteButton.group.getChildren(),true);
                this.unmuteButton.sprite.setInteractive();
            }
        }else{
            if(this.unmuteButton){
                Phaser.Actions.SetVisible(this.unmuteButton.group.getChildren(),false);
                this.scene.input.disable(this.unmuteButton.sprite);
            }
            if(this.muteButton){
                Phaser.Actions.SetVisible(this.muteButton.group.getChildren(),true);
                this.muteButton.sprite.setInteractive();
            }
        }
    }
}